import dynamic from 'next/dynamic'
import Head from 'next/head'
import type { FC, ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Spacer from 'components/Spacer'
import { Body, Heading } from 'components/Text'
import { FlexDivCol, FlexDivRowCentered } from 'components/layout/flex'
import AppLayout from 'sections/shared/Layout/AppLayout'
import media from 'styles/media'

const SocketSwap = dynamic(() => import('components/SocketBridge/SocketSwap'), { ssr: false })

type ExchangeComponent = FC & { getLayout: (page: ReactNode) => ReactElement }

const Swaps: ExchangeComponent = () => {
	const { t } = useTranslation()

	return (
		<PageContent>
			<StyledFullHeightContainer>
				<Head>
					<title>{t('swaps.page-title')}</title>
				</Head>
				<Container rowGap="25px">
					<FlexDivRowCentered>
						<FlexDivCol rowGap="5px">
							<StyledHeading variant="h4">{t('swaps.main-title')}</StyledHeading>
							<Body color="secondary">{t('swaps.copy')}</Body>
						</FlexDivCol>
					</FlexDivRowCentered>
					<Divider height={1} divider />
					<ScoketContainer>
						<SocketSwap />
					</ScoketContainer>
				</Container>
			</StyledFullHeightContainer>
		</PageContent>
	)
}

const Container = styled(FlexDivCol)`
	${media.lessThan('mdUp')`
		padding: 10px;
	`}
	${media.greaterThan('mdUp')`
		margin-top: 26px;
	`}
`

const ScoketContainer = styled.div`
	max-width: 600px;
	margin: 0 auto;
`

const PageContent = styled.section`
	display: flex;
	justify-content: center;
	width: 100%;
	height: 100%;
	${(props) => props.theme.animations.show};
`

const StyledFullHeightContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100vw;
	margin: 0 auto;
	max-width: 1200px;
	padding: 20px 100px;
	overflow-y: auto;
	scrollbar-width: none;
	${media.lessThan('lg')`
		padding: 0px;
	`}
`

const Divider = styled(Spacer)`
	width: 100%;
`

const StyledHeading = styled(Heading)`
	font-weight: 400;
`

Swaps.getLayout = (page) => <AppLayout>{page}</AppLayout>

export default Swaps
